/**
 * `/recover` — one `RouteObject`, so the file is `recover.route.tsx`.
 *
 * Unguarded, and reachable in BOTH states: from `/login` with no session, and
 * from `/settings/security` with one. One shell that works in both beats two
 * that differ by session, which is why it sits in the auth half-shell rather
 * than in the app shell.
 */
import type { RouteObject } from 'react-router-dom';

export const recoverRoute: RouteObject = {
  path: '/recover',
  lazy: async () => {
    const { RecoverPage } = await import('./RecoverPage');
    return { Component: RecoverPage };
  },
};
